// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BothCaretFilledSvg from "@fishx/icons-svg/es/asn/BothCaretFilled";
import FishxIcon from '../components/FishxIcon';

var BothCaretFilled = function BothCaretFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BothCaretFilledSvg
  }));
};

BothCaretFilled.displayName = 'BothCaretFilled';
export default React.forwardRef(BothCaretFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BothCaretFilled.js
// module id = 2105
// module chunks = 0